<template>
  <DashboardPanel title="报修工单分析">
    <div class="repair-analysis">
      <div ref="chart" class="repair-chart"></div>
      <ul class="repair-legend"><li v-for="item in status" :key="item.name"><i :style="{background:item.color}"></i><span>{{item.name}}</span><strong>{{item.value}}<small>单</small></strong><em>{{item.percent}}</em></li></ul>
      <div class="repair-metrics"><div v-for="item in metrics" :key="item.label"><i :class="item.icon" :style="{color:item.color}"></i><p><span>{{item.label}}</span><strong :style="{color:item.valueColor || '#e9f3fa'}">{{item.value}}</strong></p></div></div>
    </div>
  </DashboardPanel>
</template>
<script>
import * as echarts from 'echarts'
import DashboardPanel from './DashboardPanel.vue'
import { dashboardTooltip, formatNumber, formatPercent, toNumber } from '../dashboardFormat'

export default {
  name: 'RepairAnalysis',
  components: { DashboardPanel },
  props: { data: { type: Object, default: () => ({}) } },
  data: () => ({ chart: null }),
  computed: {
    status() {
      const rows = Array.isArray(this.data.breakdown) ? this.data.breakdown : []
      const colors = ['#348cf1', '#f5a13b', '#43bf70', '#ef554f', '#8667df']
      const result = rows.reduce((items, row) => {
        const key = row.repairState || 'unknown'
        const existing = items.find(item => item.key === key)
        if (existing) {
          existing.value += toNumber(row.repairCount)
        } else {
          items.push({ key, name: row.repairStateName || this.stateName(key), value: toNumber(row.repairCount), color: colors[items.length % colors.length] })
        }
        return items
      }, []).sort((a, b) => b.value - a.value).slice(0, 5)
      const total = result.reduce((sum, item) => sum + item.value, 0)
      return result.map(item => Object.assign(item, { percent: this.percent(item.value, total) }))
    },
    metrics() {
      const summary = this.data.summary || {}
      const total = toNumber(summary.totalRepairs)
      return [
        { label: '报修总数', value: `${this.format(total)} 单`, icon: 'el-icon-s-tools', color: '#2b8ff2' },
        { label: '完成率', value: this.percent(toNumber(summary.finishedRepairs), total), icon: 'el-icon-circle-check', color: '#3cc872', valueColor: '#3cc872' },
        { label: '超时率', value: this.percent(toNumber(summary.timeoutRepairs), total), icon: 'el-icon-time', color: '#ef554f', valueColor: '#ef554f' },
        { label: '平均处理时长', value: `${formatNumber(summary.avgProcessingHours, 1)} 小时`, icon: 'el-icon-timer', color: '#368ef0' }
      ]
    },
    total() { return toNumber((this.data.summary || {}).totalRepairs) }
  },
  watch: { data: { deep: true, handler() { this.renderChart() } } },
  mounted() {
    this.renderChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    renderChart() {
      if (!this.chart) this.chart = echarts.init(this.$refs.chart)
      this.chart.setOption({
        color: this.status.map(item => item.color),
        tooltip: dashboardTooltip({
          trigger: 'item',
          formatter: params => `${params.marker}${echarts.format.encodeHTML(params.name)}<br/>工单数：${formatNumber(params.value)} 单<br/>占比：${formatPercent(params.value, this.status.reduce((sum, item) => sum + item.value, 0))}`
        }),
        series: [{ type: 'pie', radius: ['52%', '76%'], center: ['50%', '50%'], label: { show: false }, data: this.status.map(item => ({ name: item.name, value: item.value })) }],
        graphic: [{ type: 'text', left: 'center', top: '35%', style: { text: '报修总数', fill: '#9fb3c2', fontSize: 10, textAlign: 'center' } }, { type: 'text', left: 'center', top: '47%', style: { text: this.format(this.total), fill: '#f0f7fc', fontSize: 20, fontWeight: 700, textAlign: 'center' } }, { type: 'text', left: 'center', top: '63%', style: { text: '单', fill: '#aabcc9', fontSize: 10, textAlign: 'center' } }]
      }, true)
    },
    resizeChart() { if (this.chart) this.chart.resize() },
    format(value) { return formatNumber(value) },
    percent(value, total) { return formatPercent(value, total) },
    stateName(value) {
      const map = { '1000': '未派单', '1100': '接单', '1200': '退单', '1300': '转单', '1700': '待评价', '1900': '办理完成', '2000': '未办理结单', '2001': '暂停' }
      return map[value] || `状态 ${value}`
    }
  }
}
</script>
<style lang="scss" scoped>
.repair-analysis{display:grid;grid-template-columns:128px 1fr 142px;align-items:center;height:100%;padding:0 9px 7px}.repair-chart{width:124px;height:145px}.repair-legend{margin:0;padding:0 8px 0 0;list-style:none}.repair-legend li{display:grid;grid-template-columns:7px 45px 1fr 40px;align-items:center;height:27px;color:#bdcbd6;font-size:11px;white-space:nowrap}.repair-legend i{width:7px;height:7px;border-radius:50%}.repair-legend strong{color:#edf5fa;font-size:12px;text-align:right}.repair-legend small{margin-left:2px;font-size:9px;font-weight:400}.repair-legend em{color:#879ba9;font-size:10px;font-style:normal;text-align:right}.repair-metrics{height:100%;padding-left:10px;border-left:1px solid rgba(71,125,159,.32)}.repair-metrics>div{display:flex;align-items:center;height:25%;border-bottom:1px solid rgba(63,119,156,.2)}.repair-metrics>div:last-child{border-bottom:0}.repair-metrics i{width:34px;font-size:23px}.repair-metrics p{margin:0}.repair-metrics span{display:block;color:#9fb1be;font-size:10px}.repair-metrics strong{display:block;margin-top:3px;font-size:15px;white-space:nowrap}
</style>
